module.exports = __webpack_public_path__ + "static/img/ux_right.148bb38.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/ux_right.png
// module id = 9iqp
// module chunks = 23